module.exports = __webpack_public_path__ + "img/sea-2.b08571f4.jpg";